import { Flex } from "grid-styled";
import styled from "styled-components";
import { height, themeGet } from "styled-system";

import srOnly from "../../screenReaderOnlyStyles";

export const PageContainer = styled.div`
  background-color: ${themeGet("colors.nav.95")};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const SkipLink = styled.a.attrs({
  href: "#content",
  role: "link"
})`
  ${srOnly};
`;

export const ContentContainer = styled.div`
  width: 100%;
  max-width: ${props => props.maxWidth ? props.maxWidth : `1200`}px;
  margin: 0 auto;
`;

export const ContentContainerFlex = styled(Flex)`
  width: 100%;
  max-width: ${props => props.maxWidth ? props.maxWidth : `1200`}px;
  margin: 0 auto;
  margin-left: ${props => props.ml || "auto"};
  ${height}
`;

export const Content = styled(Flex)`
  flex: 1 0 auto;
  flex-direction: column;
  position: relative;
`;
